import Box, { BoxProps } from "ds/components/Box";
import { MainNavigationItem } from "components/MainNavigation/types";

import MainNavigationListItem from "./Item";

type MainNavigationListItemsProps = {
  items: MainNavigationItem[];
  padding?: BoxProps["padding"];
};

const MainNavigationListItems = ({
  items,
  padding = "medium 0 0",
}: MainNavigationListItemsProps) => {
  return (
    <Box direction="column" gap="medium" align="start" padding={padding}>
      {items.map((item) => (
        <MainNavigationListItem key={item.id} item={item} />
      ))}
    </Box>
  );
};

export default MainNavigationListItems;
